import React, { useEffect, useRef } from "react";
import { ArrowRightOutlined } from "@ant-design/icons";
import { Form, Input, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { cleanAuthLoading, clearAuthObj, login, setToken } from "../../features/auth/authSlice";
import axiosInstance from "../../instance";
import toast from "react-hot-toast";
import { fetchMenu } from "../../features/menu/menuSlice";
import { cleanLegendClickStatus } from "../../features/global/globalSlice";
import AuthShell from "./AuthShell";

function Login() {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { authLoading } = useSelector((state) => state.auth);

  const onFinish = async (data) => {
    const res = await dispatch(login(data));
    if (res?.payload?.success) {
      await dispatch(setToken(res?.payload?.access_token));
      axiosInstance.defaults.headers.common["Authorization"] =
        await `Bearer ${res?.payload?.access_token}`;
      toast.success("Successfully logged in");
      await dispatch(cleanLegendClickStatus());
      await dispatch(fetchMenu());
      await navigate("/dashboard-main");
    } else {
      toast.error(res?.payload?.messages?.message ?? "Bad Credentials");
    }
  };

  async function clean() {
    await dispatch(clearAuthObj());
  }

  useEffect(() => {
    clean();
  }, []);

  useEffect(() => {
    dispatch(cleanAuthLoading());
  }, []);

  return (
    <AuthShell
      panelTitle="Sign in"
      panelSubtitle="Welcome back to your workspace."
    >
      <Form
        layout="vertical"
        ref={formRef}
        name="control-ref"
        onFinish={onFinish}
        style={{
          maxWidth: "100%",
        }}
        className="weiser-login-form"
        form={form}
      >
        <Form.Item
          label="Email address"
          className="login-form-item weiser-login-form-item"
          name="email"
          rules={[
            {
              required: true,
              message: "Please input your email",
            },
          ]}
        >
          <Input type="email" className="weiser-login-input" />
        </Form.Item>
        <Form.Item
          label="Password"
          className="login-form-item weiser-login-form-item"
          name="password"
          rules={[
            {
              required: true,
              message: "Please input your password",
            },
          ]}
        >
          <Input.Password className="weiser-login-input" type="password" />
        </Form.Item>

        <button
          disabled={authLoading}
          className="weiser-login-submit"
          type="submit"
        >
          {authLoading ? <Spin /> : <>Continue <ArrowRightOutlined /></>}
        </button>

        <div className="weiser-login-actions">
          <Link className="weiser-login-forgot forgot_text" to="/forgot-password">
            Forgot password?
          </Link>
        </div>
      </Form>
    </AuthShell>
  );
}

export default Login;
